import _ from '@app/utils.js'

function groupFields(parent, selectors) {
  const fields = selectors.map(s => parent.querySelector(s)).filter(Boolean)
  if (fields.length < 2) return
  const row = document.createElement('div')
  row.className = 'checkout-fields-row'
  fields[0].parentNode.insertBefore(row, fields[0])
  fields.forEach(f => row.appendChild(f))
}

_.onElementReady('.path-checkout form', form => {
  // Raggruppa campi per pane (billing e shipping hanno strutture diverse)
  form.querySelectorAll('.checkout-pane').forEach(pane => {
    // Riga: Email | Telefono | PEC
    groupFields(pane, [
      '.field--name-field-email',
      '.field--name-field-telefono',
      '.field--name-field-pec',
    ])

    // Riga: Partita IVA | Codice Fiscale | SDI
    groupFields(pane, [
      '.field--name-field-vat-number',
      '.field--name-field-codice-fiscale',
      '.field--name-field-codice-sdi',
    ])
  })

  // Aggiunge il pulsante × per svuotare ogni campo testo/email
  form.querySelectorAll('input.form-text, input.form-email').forEach(input => {
    const item = input.closest('.form-item')
    if (!item || input.disabled) return

    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'field-clear-btn'
    btn.setAttribute('aria-label', Drupal.tt('Cancella campo'))
    btn.innerHTML = '&times;'
    btn.style.display = input.value ? '' : 'none'

    btn.addEventListener('click', () => {
      input.value = ''
      input.dispatchEvent(new Event('input', { bubbles: true }))
      input.focus()
      btn.style.display = 'none'
    })

    input.addEventListener('input', () => {
      btn.style.display = input.value ? '' : 'none'
    })

    item.appendChild(btn)
  });

  // Disabilita il campo country code del billing address quando il suo wrapper è disabled
  // poiché questo campo sembra essere gestito differentemente dal resto del form.
  form.querySelectorAll('.js-form-wrapper[disabled] .country.form-select').forEach(input => {
    input.disabled = true;
  });
})
